import React from 'react'
import { Heading , Alert, Text } from 'base-ui'
import Highlighter from './Highlight'
import { Alert as AlertExample } from '../examples/Alert'
import { PageWrapper } from './PageWrapper'
import { IconAward } from '@paro.io/base-icons'

const Alerts = () => {
  return (
    <PageWrapper title="Alerts">
      <Text size="md">
        Alerts are used to communicate a state that affects a system, feature or page.
      </Text>
        <div className='bg-white rounded-md py-8'>
          <div className="space-y-2">
            <Alert label="Default Alert" iconCustom={<IconAward size="sm"/>}/>
            <Alert label="Branded Alert" iconCustom={<IconAward size="sm"/>} color='primary' />
          </div>
          <Heading size="h3">Variant</Heading>
          <div className="space-y-2 mb-8">
            <Alert label="Branded Alert" iconCustom={<IconAward size="sm"/>} color='primary' />
            <Alert label="Informative alert solid" icon="info" color="info"/>
            <Alert label="Warning alert solid" icon="warning" color="warning"/>
            <Alert label="Danger alert solid" icon="danger" color="danger"/>
            <Alert label="Success alert solid" icon="success" color="success"/>
          </div>
          <div className="space-y-2 mb-8">
            <Alert label="Default alert subtle" iconCustom={<IconAward size="sm"/>}/>
            <Alert label="Informative alert subtle" icon="info" color="info" variant="subtle"/>
            <Alert label="Warning alert subtle" icon="warning" color="warning" variant="subtle"/>
            <Alert label="Danger alert subtle" icon="danger" color="danger" variant="subtle"/>
            <Alert label="Success alert subtle" icon="success" color="success" variant="subtle"/>
          </div>
          <div className="space-y-4">
            <Alert label="Branded alert outline" iconCustom={<IconAward size="sm"/>} color="primary" variant="outline"/>
            <Alert label="Informative alert outline" icon="info" color="info" variant="outline"/>
            <Alert label="Warning alert outline" icon="warning" color="warning" variant="outline"/>
            <Alert label="Danger alert outline" icon="danger" color="danger" variant="outline"/>
            <Alert label="Success alert outline" icon="success" color="success" variant="outline"/>
          </div>
          <Heading size="h3">Usage</Heading>
          <Highlighter code={AlertExample} language='jsx' />
        </div>
    </PageWrapper>
  )
}

export default Alerts
